<div
  class="load-image"
  (click)="openImage()"
  [ngClass]="{ circle: typeImage === 'circle', square: typeImage === 'square' }"
  [ngStyle]="{ 'width.px': width, 'height.px': height }"
>
  <i
    class="fas fa-camera-retro logo"
    [ngClass]="{ 'loaded-image': urlImage !== '' }"
  ></i>
  <img [src]="sanitize()" alt="" />
  <input type="file" #loadImage class="d-none" (change)="changeImage()" />
</div>
